import { buildTabExecutionScopeId, getBrowserTabId } from '../../../data/browserTabExecutionIdentity'

// CFO Core's browser-DuckDB dataset id. Mirrors the value used by CfoHomeBrief /
// AppWorkerClient so the copilot's analytic tools query the same live tables.
export const CFO_CORE_DUCKDB_DATASET_ID = '__fg_cfo_core_duckdb__'

export const buildCfoDuckDbOpts = (workbookId: string | null | undefined): Record<string, any> | null => {
  const wb = String(workbookId || '').trim()
  if (!wb) return null
  return {
    executionScopeId: buildTabExecutionScopeId({
      browserTabId: getBrowserTabId(),
      workbookScopeId: wb,
    }),
    persistentAdHoc: true,
    persistentDatasetId: CFO_CORE_DUCKDB_DATASET_ID,
  }
}
